import { useContext, useEffect, useState } from "react";
import { SmartContext } from "../../../../library/Core/SmartContext";
import SessionContext from "../../../../library/Core/SessionContext";
import JobListingService from "../../../jobs/listing/JobListingService";
// import IntrestedJobPageConfig from '../../../jobs/listing/IntrestedJobPageConfig.json';

import ApplyNowPageConfig from '../../../jobs/listing/ApplyNowPageConfig.json';
import CloseJobPageConfig from '../../../jobs/listing/CloseJobPageConfig.json';
import IntrestedJobPageConfig from '../../../jobs/listing/IntrestedJobPageConfig.json';
import ApplyNowModal from '../../../jobs/listing/ApplyNowModal';
import ViewDescriptionModal from '../../../jobs/listing/ViewDescriptionModal';
import CloseJobModal from '../../../jobs/listing/CloseJobModal';
import IntrestedJobModal from '../../../jobs/listing/IntrestedJobModal';
import ViewIntrestedJobModal from '../../../jobs/listing/ViewIntrestedJobModal';
import ViewApplicationModal from '../../../jobs/listing/ViewApplicationModal';
import ViewAppliedsModal from '../../../jobs/listing/ViewAppliedsModal';
import SendMessageToInterestedModal from '../../../jobs/listing/SendMessageToIntrested';
import { useParams } from "react-router-dom";
import { getDomainValueForCode, getTimeAgo, isSchoolAdmin, underScoreToTitleCase } from "../../../../library/Core/SmartFunctions";
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import { Tooltip } from "bootstrap";

const JobListing = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { sessionState } = useContext(SessionContext);
    const { id, pageName } = useParams();
    const [jobs, setJobs] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true); // Loading state to manage the loading spinner

    useEffect(() => fetchJobs(), [state.internal?.refreshJobs]);

    useEffect(() => {
        // Initialize tooltips after jobs are loaded
        if (jobs.length > 0) {
            const tooltipTriggerList = [].slice.call(document.querySelectorAll(".defaultTooltip"));
            tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
        }
    }, [jobs]); // Runs after jobs are updated

    const fetchJobs = () => {
        let searchBy = 'LISTED_BY_USER';
        const schoolAdminRoles = ['INSTITUTE_ADMIN', 'INSTITUTE_SUPPORT_MANAGER', 'INSTITUTE_MARKETING_MANAGER'];

        if (schoolAdminRoles.includes(sessionState?.userTypeCode as string) || sessionState?.userTypeCode === 'SUPER_ADMIN') {
            searchBy = "USER_LIST_BY_ADMIN";
        }

        if (searchBy === 'LISTED_BY_USER' && id !== sessionState?.userId) {
            searchBy = 'LISTED_BY_OTHER_USER';
        }

        JobListingService.get({ searchBy: searchBy, userId: id }).then((jobsResponse) => {
            setJobs(jobsResponse.data.data);
            setIsLoading(false); // Set loading state to false once data is fetched
        });
    };

    const handleSavePreference = (params: any) => {
        JobListingService.savePreference(params);
        setTimeout(() => refresh(), 0);
    };

    const [activeModal, setActiveModal] = useState(null);
    const loadPageConfig = async (configPromise: any, modalType: any) => {
        try {
            setActiveModal(null);
            const config = await Promise.resolve(configPromise);
            dispatch({
                type: 'DATA_INIT',
                payload: {
                    formConfig: config,
                    data: {
                        ...state.data,
                        jobPostingAppliedJobs: {},
                        jobPostingCloseJob: {},
                        jobPostingIntrestedJob: {},
                    },
                    domain: new Map([...state.domain]),
                    internal: state.internal,
                    routeInfo: state.routeInfo,
                },
            });

            setActiveModal(modalType);
        } catch (error) {
            console.error('Error fetching page config:', error);
        }
    };

    const handleOpenModal = async (
        job: any,
        modalType:
            | 'APPLY'
            | 'CLOSE'
            | 'INTRESTED'
            | 'VIEW_INTERESTED'
            | 'VIEW_APPLICATION'
            | 'SEND_MESSAGE_TO_INTERESTED'
            | 'VIEW_APPLIEDS',
        pageConfig?: any
    ) => {
        const notRecruiredPageconfig = ['VIEW_INTERESTED', 'VIEW_APPLICATION', 'VIEW_APPLIEDS', 'SEND_MESSAGE_TO_INTERESTED'];
        if (!notRecruiredPageconfig.includes(modalType) && pageConfig) {
            await loadPageConfig(pageConfig, modalType);
        }

        dispatch({
            type: 'SET_MODAL_DATA',
            payload: { data: job },
        });

        dispatch({
            type: 'TOGGLE_MODAL_VISIBILITY',
            payload: {
                modalName:
                    modalType === 'APPLY'
                        ? 'showJobPostingApplyNow'
                        : modalType === 'SEND_MESSAGE_TO_INTERESTED'
                        ? 'showSendMessageToInterestedModal'
                        : modalType === 'CLOSE'
                        ? 'showJobPostingCloseJob'
                        : modalType === 'INTRESTED'
                        ? 'showJobPostingIntrested'
                        : modalType === 'VIEW_APPLICATION'
                        ? 'showJobViewApplication'
                        : modalType === 'VIEW_APPLIEDS'
                        ? 'showJobViewApplieds'
                        : 'showJobViewInterested',
            },
        });
    };


    const handleViewJobDescription = (job: any) => {
        dispatch({ type: 'SET_MODAL_DATA', payload: { data: job } });
        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showJobPostingViewDescription' } });
    };
    
    const handleSendMessage = (event: any, id: string) => {
        event.preventDefault();
        state.actions['ROUTER_NAVIGATE'](`/messages/send-message/${id}`);
    };

    const refresh = () => dispatch({ type: 'SET_INTERNAL_STATE', payload: { key: 'refreshJobs', value: uuidv4() } });

    return (
        <>
            <div className="tab-pane fade show active" id="pills-job-listings" role="tabpanel" aria-labelledby="pills-job-listings-tab" tabIndex={0}>
                <div className="contributions-block p-0 bg-transparent disable-boxshadow">
                    <div className="jobsandInternshipssection">
                        <div className="jobsandInternshipslist">
                            <div className="row g-3">
                            {isLoading ? (
                                // Show loading spinner while data is being fetched
                                <div className="loading-spinner">
                                    <span>Loading...</span> {/* You can replace this with a spinner icon */}
                                </div>
                            ) : jobs.length > 0 ? (
                                // Show job listings when data is loaded
                                jobs.map((job) => (
                                    <div key={job.id} data-job-id={job.id} className="col-md-12">
                                        <div className="bg-white rounded p-4 position-relative overflow-hidden">
                                            {job.statusCode === 'CLOSED' && (
                                                <div className="position-absolute bg-danger text-white top-left-sticker">
                                                    <span className="font-12 font-500 lh-1"> Closed </span>
                                                </div>
                                            )}
                                            <div className="row g-3">
                                                <div className="col-md-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-md">
                                                            <div className="font-22 font-600 text-dark-blue">
                                                                {underScoreToTitleCase(job.jobTypeCode)}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-auto">
                                                            <div className="row g-2 align-items-center">
                                                                <div className="col-md-auto">
                                                                    <div className="font-12 font-500 text-dark-blue">
                                                                        <i>Posted by:</i> {`${job.firstName} ${job.lastName}`},{' '}
                                                                        {job.programName} {job.passOutYear}
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-auto">
                                                                    <span className="badge text-bg-secondary bg-opacity-25 text-dark font-12 font-400 rounded-pill align-top">
                                                                        {/* {moment().diff(job.createdAt, 'days') > 0
                                                                            ? moment().diff(job.createdAt, 'days') + 'days ago'
                                                                            : 'today'} */}
                                                                        {getTimeAgo(job.createdAt)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="bg-gray-f5f5f5 font-16 font-600 text-black px-3 py-2 rounded">
                                                        {/* {job.title} @ {job.companyName} */}
                                                        {job.title} @{' '}
                                                        {job.companyId
                                                            ? getDomainValueForCode(job.companyId, 'COMPANY_CODE', state)
                                                            : job.otherCompany}
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="row g-2">
                                                        <div className="col-auto">
                                                            <i className="bi bi-geo-alt-fill me-2 text-dark-blue"></i>
                                                            {getDomainValueForCode(job.cityCode, 'CITY_CODE', state)}
                                                        </div>
                                                        {job.experienceLevelCode && (
                                                            <div className="col-auto">
                                                                <i className="bi bi-briefcase-fill ms-3 me-1 text-dark-blue"></i>{' '}
                                                                {/* {job.minExperience} - {job.maxExperience} Year Experience */}
                                                                {getDomainValueForCode(
                                                                    job.experienceLevelCode,
                                                                    'WORK_EX_PREFERENCE',
                                                                    state
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <hr className="my-2 opacity-25" />
                                                    <div className="row g-2">
                                                        <div className="col-auto">
                                                            <i className="bi bi-eye me-2 text-dark-blue"></i> {job.totalViewedCnt} views
                                                        </div>
                                                        <div className="col-auto">
                                                            <i className="bi bi-star ms-3 me-2 text-warning"></i>{' '}
                                                            {job.totalInterestedCnt} interested
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="row g-2">
                                                        <div className="col-auto">
                                                            <button
                                                                className="btn btn-dark-blue font-14 font-500 text-white w-auto height-35"
                                                                onClick={() => {
                                                                    handleViewJobDescription(job);
                                                                    if (!isSchoolAdmin() && (job.studentId != sessionState?.id)) {
                                                                        handleSavePreference({
                                                                            jobId: job?.id,
                                                                            isSaved: job?.isSaved,
                                                                            isViewed: 1,
                                                                        });
                                                                    }
                                                                }}>
                                                                <span>View Job Description</span>
                                                            </button>
                                                        </div>
                                                        {!job.isInterested &&
                                                            job.studentId != sessionState?.id &&
                                                            !isSchoolAdmin() &&
                                                            sessionState?.userTypeCode !== 'SUPER_ADMIN' && (
                                                                <div className="col-auto hide">
                                                                    <button
                                                                        className="btn btn-gold-f1ac18 rounded-pill font-14 font-500 text-white height-35 px-4"
                                                                        onClick={() =>
                                                                            handleOpenModal(job, 'INTRESTED', IntrestedJobPageConfig)
                                                                        }>
                                                                        <span>I'm Interested</span>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        {job.isInterested &&
                                                            job.studentId != sessionState?.id &&
                                                            !isSchoolAdmin() &&
                                                            sessionState?.userTypeCode !== 'SUPER_ADMIN' && (
                                                                <div className="col-auto hide">
                                                                    <button
                                                                        className="btn btn-border-gray rounded-pill font-14 font-500 height-35 px-4"
                                                                        onClick={(event) => handleSendMessage(event, job.studentId)}>
                                                                        <span>Follow-up</span>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        {!isSchoolAdmin() && job.isApplied == 0 && job.studentId != sessionState?.id && (
                                                            <div className="col-auto hide">
                                                                <button
                                                                    className="btn btn-green font-14 font-500 text-white height-35"
                                                                    onClick={() => handleOpenModal(job, 'APPLY', ApplyNowPageConfig)}>
                                                                    <span>Apply Now</span>
                                                                </button>
                                                            </div>
                                                        )}
                                                        {job.isApplied == 1 && (
                                                            <div className="col-auto hide">
                                                                <button
                                                                    className="btn btn-green font-14 font-500 text-white height-35"
                                                                    onClick={() => handleOpenModal(job, 'VIEW_APPLICATION')}>
                                                                    <span>View Application</span>
                                                                </button>
                                                            </div>
                                                        )}
                                                        {job.studentId == sessionState?.id && job.statusCode != 'CLOSED' && (
                                                            <div className="col-auto hide">
                                                                <button
                                                                    className="btn btn-danger rounded-pill font-14 font-500 text-white height-35 px-4"
                                                                    onClick={() => handleOpenModal(job, 'CLOSE', CloseJobPageConfig)}>
                                                                    <span>Close Job</span>
                                                                </button>
                                                            </div>
                                                        )}

                                                        {job.studentId === sessionState?.id && job.totalInterestedCnt > 0 && (
                                                            <div className="col-auto hide">
                                                                <button
                                                                    className="btn btn-green font-14 font-500 text-white height-35"
                                                                    onClick={() => handleOpenModal(job, 'VIEW_INTERESTED')}>
                                                                    <span>View Interested ({job.totalInterestedCnt})</span>
                                                                </button>
                                                            </div>
                                                        )}

                                                        {job.studentId === sessionState?.id && job.totalInterestedCnt > 0 && (
                                                            <div className="col-auto hide">
                                                                <button
                                                                    className="btn btn-gold-f1ac18 rounded-pill font-14 font-500 text-white height-35 px-4"
                                                                    onClick={() => handleOpenModal(job, 'SEND_MESSAGE_TO_INTERESTED')}>
                                                                    <span>Message All ({job.totalInterestedCnt})</span>
                                                                </button>
                                                            </div>
                                                        )}

                                                        {job.studentId === sessionState?.id && job.totalApplicantCnt > 0 && (
                                                            <div className="col-auto hide">
                                                                <button
                                                                    className="btn btn-green font-14 font-500 text-white height-35"
                                                                    onClick={() => handleOpenModal(job, 'VIEW_APPLIEDS')}>
                                                                    <span>View Applied ({job.totalApplicantCnt})</span>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row m-0 d-flex flex-wrap justify-content-between align-items-end">
                                            <div className="pe-0 text-end">
                                                <div className="d-flex flex-wrap justify-content-end"></div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12">
                                    <span className="video_block_name">
                                        <label>No Jobs Available</label>
                                    </span>
                                </div>
                            )}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal for View Description */}
            <ViewDescriptionModal />
            {/* Modal for Apply Now */}
            {activeModal === 'APPLY' && <ApplyNowModal />}
            {activeModal === 'CLOSE' && <CloseJobModal />}
            {activeModal === 'INTRESTED' && <IntrestedJobModal />}{' '}
            {state?.modalFlags?.showJobViewInterested && <ViewIntrestedJobModal handleOpenModal={handleOpenModal} />}
            {state?.modalFlags?.showJobViewApplication && <ViewApplicationModal />}
            {state?.modalFlags?.showJobViewApplieds && <ViewAppliedsModal handleOpenModal={handleOpenModal} />}
            {state?.modalFlags?.showSendMessageToInterestedModal && <SendMessageToInterestedModal handleOpenModal={handleOpenModal} />}
        </>
    );
};

export default JobListing;
